import React from 'react';
import {
  View,
  StyleSheet,
  StyleProp,
  ViewStyle,
  TextStyle,
  GestureResponderEvent,
} from 'react-native';
import AVText from 'src/components/elements/AVText';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import Styles from 'src/components/Styles';

export interface BarButtonProps {
  leftIcon?: React.ReactNode;
  leftText: string;
  rightText?: string;
  onPress: (e: GestureResponderEvent) => void;
  disabled?: boolean;
  disabledColor?: string;
  containerStyle?: StyleProp<ViewStyle>;
  buttonViewStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  testID?: string;
  leftTestID?: string;
  rightTestID?: string;
}

export const BarButton: React.FC<BarButtonProps> = ({
  leftIcon,
  leftText,
  rightText,
  onPress,
  disabled = false,
  containerStyle,
  buttonViewStyle,
  textStyle,
  testID,
  leftTestID,
  rightTestID,
}) => {
  return (
    <AVTouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[styles.container, containerStyle]}
      accessible
      testID={testID}
      nativeID={testID}
    >
      <View style={[styles.buttonView, buttonViewStyle]}>
        <View
          style={styles.left}
          accessible
          testID={leftTestID}
          nativeID={leftTestID}
        >
          {leftIcon && <View style={styles.icon}>{leftIcon}</View>}
          <AVText numberOfLines={1} style={[styles.leftText, textStyle]}>
            {leftText}
          </AVText>
        </View>
        {rightText && (
          <AVText
            numberOfLines={1}
            style={[styles.rightText, textStyle]}
            accessible
            testID={rightTestID}
            nativeID={rightTestID}
            accessibilityLabel={rightText}
            aria-label={rightText}
          >
            {rightText}
          </AVText>
        )}
      </View>
    </AVTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    alignSelf: 'flex-start',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: Styles.MinTouchableArea,
  },
  buttonView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: Styles.Spacing.m4,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  icon: {
    marginRight: Styles.Spacing.m2,
  },
  leftText: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    flexShrink: 1,
    color: Styles.Colors.PayNew.white01,
  },
  rightText: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    color: Styles.Colors.PayNew.white01,
  },
});
